module.exports = __webpack_public_path__ + "img/ysgj_005@2x.d814ced8.png";